import { get as networkGet } from '../../networkClient';

/**
 * Fetches communities for a given client
 * @param {string} clientId - The tenant/client ID
 * @returns {Promise<Object>} Array of community objects
 */
export async function getCommunities(clientId) {
  try {
    const response = await networkGet(
      `/communities/?client_id=${clientId}`,
      null,
      null,
      true,
      true
    );
    return response?.data;
  } catch (error) {
    return {
      error: true,
      message: error.message,
      status: error.response?.status
    };
  }
}

/**
 * Fetches community data for a specific community by ID
 * @param {string} communityId - The community/apartment ID
 * @returns {Promise<Object>} Community data
 */
export async function getCommunityById(communityId) {
  try {
    // Use useNewBaseUrl=true to hit REACT_APP_SERVER_URL_V2 which routes to rb-backend-apis
    // The base URL already includes /apis/v1, so just use /communities/:communityId
    const response = await networkGet(
      `/communities/${communityId}`,
      null,
      null,
      true,
      true
    );
    return response?.data;
  } catch (error) {
    return {
      error: true,
      message: error.message,
      status: error.response?.status
    };
  }
}
